/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       NewReservationPeriodScreenStyle.ts
 * @author     Christian Ascone
 * @date       12/27/19 10:16 AM
 */

import {Platform, StyleSheet} from "react-native";
import {Header} from "@react-navigation/stack";
import Layout from "../../../config/Layout";

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: '#fff',
        top: 0,
        bottom: 0,
        height: Layout.window.height - 2*Header.HEIGHT,
        ...Platform.select({
            web:{
                maxHeight: Layout.window.height - Header.HEIGHT,
                minHeight: Layout.window.height - Header.HEIGHT,
            }
        }),

    },
    scrollContainer: {
        flex: 1,
        backgroundColor: '#fff',
        marginTop: 50,
    },
    contentContainer: {
        justifyContent: 'space-between',

    },

    inputContainer: {
        ...Platform.select({
            web: {
                flexDirection: 'column',
            },
        }),
        height: '75%',
        marginTop: 10,
        marginBottom: 20,
    },
    DateTimeInputBlock: {
        
    },
    flex: {
        flex: 1,
    },
    getStartedContainer: {
        height: '100%',
    },
});

export default styles;